import { AnimatePresence, motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';

export const MoreSheet = ({ open, onClose, tabs, activeTab, onSelect, accent }) => (
  <AnimatePresence>
    {open && (
      <>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
          className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm md:hidden"
          data-testid="more-sheet-overlay"
        />
        <motion.div
          initial={{ y: '100%' }}
          animate={{ y: 0 }}
          exit={{ y: '100%' }}
          transition={{ type: 'spring', stiffness: 400, damping: 40 }}
          drag="y"
          dragConstraints={{ top: 0 }}
          dragElastic={0.1}
          onDragEnd={(_, info) => info.offset.y > 80 && onClose()}
          className="fixed inset-x-0 bottom-0 z-50 rounded-t-[28px] border-t border-white/10 bg-[#18181b] px-4 pt-2 pb-safe md:hidden"
          data-testid="more-sheet"
        >
          <div className="mx-auto mb-3 h-1.5 w-10 rounded-full bg-white/15" />
          <p className="px-2 pb-2 text-xs font-semibold uppercase tracking-widest text-[#71717a]">More</p>
          <div className="mb-4 overflow-hidden rounded-2xl bg-[#09090b]/60 divide-y divide-white/[0.06]">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              const active = tab.value === activeTab;
              return (
                <button
                  key={tab.value}
                  type="button"
                  data-testid={`${tab.value}-tab`}
                  onClick={() => { onSelect(tab.value); onClose(); }}
                  className="tap-none flex w-full items-center gap-4 px-4 py-3.5 text-left active:bg-white/[0.04]"
                >
                  <span
                    className="flex h-10 w-10 items-center justify-center rounded-xl"
                    style={{ backgroundColor: active ? `${accent}26` : 'rgba(255,255,255,0.05)' }}
                  >
                    <Icon className="h-5 w-5" style={{ color: active ? accent : '#a1a1aa' }} />
                  </span>
                  <span className="flex-1 text-[15px] font-semibold text-white">{tab.label}</span>
                  {tab.badge > 0 && (
                    <span className="rounded-full px-2 py-0.5 text-[11px] font-bold text-black" style={{ backgroundColor: accent }}>
                      {tab.badge}
                    </span>
                  )}
                  <ChevronRight className="h-4 w-4 text-[#52525b]" />
                </button>
              );
            })}
          </div>
        </motion.div>
      </>
    )}
  </AnimatePresence>
);
